import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ImpersonationBanner from "./components/ImpersonationBanner";
import ErrorBoundary from "./components/ErrorBoundary";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import NewBilan from "./pages/NewBilan";
import BilanDetail from "./pages/BilanDetail";
import PlatformLocked from "./pages/PlatformLocked";
import TutorEvaluation from "./pages/TutorEvaluation";
import { TutorLogin, TutorSpace } from "./pages/TutorSpace";
import ReviewsPage from "./pages/Reviews";
import Courses from "./pages/Courses";
import Progression from "./pages/Progression";
import Agenda from "./pages/Agenda";
import Bulletins from "./pages/Bulletins";
import AdminDashboard from "./pages/AdminDashboard";
import PublicAgenda from "./pages/PublicAgenda";
import CGV from "./pages/legal/CGV";
import CGU from "./pages/legal/CGU";
import Confidentialite from "./pages/legal/Confidentialite";
import MentionsLegales from "./pages/legal/MentionsLegales";
import Contact from "./pages/Contact";
import Account from "./pages/Account";
import Messages from "./pages/Messages";
import AdminContactInbox from "./pages/AdminContactInbox";
import AdminUsers from "./pages/AdminUsers";
import Formateurs from "./pages/Formateurs";
import FormateurDetail from "./pages/FormateurDetail";
import FormateurTracking from "./pages/FormateurTracking";
import BilanGlobal from "./pages/BilanGlobal";
import Students from "./pages/Students";
import Promotions from "./pages/Promotions";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Cookies from "./pages/legal/Cookies";
import Compliance from "./pages/Compliance";

function App() {
    return (
        <div className="App">
            <ErrorBoundary>
                <AuthProvider>
                    <BrowserRouter>
                        <Toaster position="top-right" richColors />
                        <ImpersonationBanner />
                        <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password/:token" element={<ResetPassword />} />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/locked"
                            element={
                                <ProtectedRoute>
                                    <PlatformLocked />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/bilans/nouveau"
                            element={
                                <ProtectedRoute requireRole="alternant" requirePlatformSubscription>
                                    <NewBilan />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/bilans/:id"
                            element={
                                <ProtectedRoute>
                                    <BilanDetail />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/tuteur/:bilanId/:token" element={<TutorEvaluation />} />
                        <Route path="/tuteur" element={<TutorLogin />} />
                        <Route path="/tuteur/:code/evaluer" element={<TutorEvaluation />} />
                        <Route path="/tuteur/:code" element={<TutorSpace />} />
                        <Route path="/rdv/:inviteCode" element={<PublicAgenda />} />
                        <Route
                            path="/cours"
                            element={
                                <ProtectedRoute>
                                    <Courses />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/progression/:id"
                            element={
                                <ProtectedRoute>
                                    <Progression />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/agenda"
                            element={
                                <ProtectedRoute>
                                    <Agenda />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/bulletins"
                            element={
                                <ProtectedRoute>
                                    <Bulletins />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <AdminDashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/avis"
                            element={
                                <ProtectedRoute>
                                    <ReviewsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/cgv" element={<CGV />} />
                        <Route path="/cgu" element={<CGU />} />
                        <Route path="/confidentialite" element={<Confidentialite />} />
                        <Route path="/mentions-legales" element={<MentionsLegales />} />
                        <Route path="/cookies" element={<Cookies />} />
                        <Route
                            path="/conformite"
                            element={
                                <ProtectedRoute requireRole="formateur">
                                    <Compliance />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/contact" element={<Contact />} />
                        <Route
                            path="/account"
                            element={
                                <ProtectedRoute>
                                    <Account />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/compte"
                            element={
                                <ProtectedRoute>
                                    <Account />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/messages"
                            element={
                                <ProtectedRoute>
                                    <Messages />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/messages/:partnerId"
                            element={
                                <ProtectedRoute>
                                    <Messages />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/inbox"
                            element={
                                <ProtectedRoute>
                                    <AdminContactInbox />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin/users"
                            element={
                                <ProtectedRoute>
                                    <AdminUsers />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/formateurs"
                            element={
                                <ProtectedRoute>
                                    <Formateurs />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/formateurs/:id"
                            element={
                                <ProtectedRoute>
                                    <FormateurDetail />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/suivi-formateurs"
                            element={
                                <ProtectedRoute>
                                    <FormateurTracking />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/alternants/:id/bilan-global"
                            element={
                                <ProtectedRoute>
                                    <BilanGlobal />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/etudiants"
                            element={
                                <ProtectedRoute requireRole="formateur">
                                    <Students />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/promotions"
                            element={
                                <ProtectedRoute requireRole="formateur">
                                    <Promotions />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            </ErrorBoundary>
        </div>
    );
}

export default App;
